import { useParams } from "react-router";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { ItemsTable } from "@/services/backend/htz/report/components/items-table";
import { ReportAhuSchema } from "@/routes/processes/[processId]/htz/reports/[reportId]/items/_components/report-ahu-schema";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import t from "@/lang/lang";

export function ItemsRoute() {
  const { reportId } = useParams();

  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! });

  if (isLoading) {
    return <CardSkeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Komponenten")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie eine Zusammenfassung der einzelnen Bewertungen für alle Komponenten sehen.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <ReportAhuSchema report={report!} />
        <ItemsTable report={report!} />
      </CardContent>
    </Card>
  );
}
